<template>
  <div>
    <div style="float:left">
      <el-radio-group :size="size" @change="handleChange" v-model="tValue" :loading="loading" v-if="isButton">
        <el-radio-button v-for="item in optionsData" :key="item[valueKey]" :label="item[valueKey]"
          :disabled="item.disabled">{{ item[labelKey]}}</el-radio-button>
      </el-radio-group>
      <el-radio-group :size="size" @change="handleChange" v-model="tValue" :loading="loading" v-if="!isButton">
        <el-radio-button v-for="item in optionsData" :key="item[valueKey]" :label="item[valueKey]"
          :disabled="item.disabled">{{ item[labelKey]}}</el-radio-button>
      </el-radio-group>
    </div>

    <div v-if="isTips">
      <p style="float:left;padding-left:20px;color: red;">提示：{{ valTips }}</p>
    </div>
  </div>
</template>
<script>
import API from "@utils/request";
import { getDictionaryKeyVal } from '@/api/DataDictionary'
import { Empty } from 'element-ui'
export default {
  name: 'TryRadio',
  props: {
    url: { // 接口地址
      type: String,
      default: undefined
    },
    valueKey: { // 列表中选项的值对应的key
      type: String,
      default: 'value'
    },
    labelKey: { // 列表中选项的标签对应的key
      type: String,
      default: 'key'
    },
    dictName: { // 字典值
      type: String,
      default: ''
    },
    isEdit: { // 是否编辑模式
      type: Boolean,
      default: false
    },
    isButton: { // 是否启用按钮模式
      type: Boolean,
      default: false
    },

    value: {// 绑定的值
      type: [String, Number, Array],
      default: undefined
    },

    size: { // medium/small/mini
      type: String,
      default: 'medium'
    },

    options: {//数据源
      type: [Array, Object],
      default: undefined
    },
    require: {//是否验证必填
      type: Boolean,
      default: false
    },
    valTips: {//验证提示
      type: String,
      default: '必选项！'
    },
    parameData:{//Url带入参数
      type: [String, Number, Array],
      default: undefined
    }

  },
  data() {
    return {
      loading: false,
      isTips: false,//是否显示提示
      tValue: this.value,
      optionsData: this.options,
    }
  },
  watch: {
    value(n, o) { // 监听父组件值变动，子组件也要变动
      this.tValue = n;
      if (this.require) {
        if (n) {
          this.isTips = false;
        }
      }
      if ((o === undefined && this.isEdit) || (o !== undefined && o.length === 0 && this.isEdit)) {
        // 如果旧的值等于undefined
        this.requestData();
      }
    },
    options(n, o) {
      this.optionsData = n;
    }
  },
  created() {
    if (this.require && (this.tValue == undefined || this.tValue.length == 0)) {
      this.isTips = true;
    }
    this.requestData();
  },
  methods: {
    // 请求数据
    async requestData() {

      if (this.dictName) {
        this.loading = true;
        let { data: res } = await getDictionaryKeyVal(this.dictName);
        this.optionsData = res;
        this.loading = false;
      } else if (this.url) {
        try {
          let { data: res } = await API.post(this.url,eval('(' + this.parameData + ')'));
          this.optionsData = res;
        } catch (error) {
          return error;
        }
      }

    },
    // 子组件值变化要通过父组件
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
